import { combineReducers, Reducer } from "redux";
import { TimeRangePreset } from "@features/query-search/DatetimeRangePicker";
import { DurationPreset } from "@features/query-search/DurationPicker";
import { EthErrorPreset } from "@features/query-search/EthErrorCodePicker";
import { HttpStatusPreset } from "@features/query-search/HttpStatusCodePicker";
// eslint-disable-next-line import/no-cycle -- Ignoring all legacy import cycles
import {
  BackendCustomFilter,
  getFilteredRequests,
  getNumFilteredRequests,
} from "../http/endpoints";
import { AppRequest } from "@features/app-details/appRequest";
import {
  Loadable,
  makeFetchThunkActionCreator,
  makeLoadingActionCreators,
  reducerForLoadable,
} from "../util/loadable";

export interface FilteredRequestsState {
  results: Loadable<AppRequest[]>;
  total_num_results: Loadable<number>;
}

export interface CustomFilter extends BackendCustomFilter {
  time_range_preset: TimeRangePreset;
  duration_preset: DurationPreset;
  http_status_preset: HttpStatusPreset;
  eth_error_preset: EthErrorPreset;
}

const requestFilteredRequests = makeLoadingActionCreators<
  CustomFilter,
  AppRequest[]
>("REQUEST_FILTERED_REQUESTS");

export const fetchFilteredRequests = makeFetchThunkActionCreator<
  CustomFilter,
  AppRequest[]
>({
  actionCreators: requestFilteredRequests,
  getFromState: (state) => state.filteredRequests.results,
  fetchResult: (filter) =>
    getFilteredRequests({ filters: toBackendFilter(filter) }),
  restartOnAdditionalCalls: true,
});

const numRequestFilteredRequests = makeLoadingActionCreators<
  CustomFilter,
  number
>("NUM_REQUEST_FILTERED_REQUESTS");

export const fetchNumFilteredRequests = makeFetchThunkActionCreator<
  CustomFilter,
  number
>({
  actionCreators: numRequestFilteredRequests,
  getFromState: (state) => state.filteredRequests.total_num_results,
  fetchResult: (filter) =>
    getNumFilteredRequests({ filters: toBackendFilter(filter) }),
  restartOnAdditionalCalls: true,
});

function toBackendFilter(filter: CustomFilter): BackendCustomFilter {
  const result: Partial<CustomFilter> = { ...filter };
  delete result.time_range_preset;
  delete result.duration_preset;
  delete result.http_status_preset;
  delete result.eth_error_preset;
  return result;
}

export const filteredRequestsReducer: Reducer<FilteredRequestsState> =
  combineReducers({
    results: reducerForLoadable(requestFilteredRequests),
    total_num_results: reducerForLoadable(numRequestFilteredRequests),
  });
